import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import { Logos } from "@/libraries/design/patterns";

import { UniformLogo, flattenLogoProps } from "../../../contenttypes/logo";

export interface UniformLogosProps {
    title?: string;
    logos: UniformLogo[];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const UniformLogos = (intakeProps: any) => {
    const { title, logos }: UniformLogosProps = flattenLogoProps(intakeProps);
    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column",
                gap: token("space.600"),
                [media.above.md]: {
                    gap: token("space.800")
                },
                textAlign: "center"
            })}
        >
            {title && <h3 css={css({ margin: 0 })}>{title}</h3>}
            <Logos logos={logos} />
        </div>
    );
};

export default UniformLogos;
